import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import MyQuest from './pages/MyQuest';
import Treasure from './pages/Treasure';
import Projects from './pages/Projects';

import BritishLibrary from './pages/BritishLibrary';
import MyClicks from './pages/MyClicks';
import EcoVeterans from './pages/EcoVeterans';
import GlobalCambridge from './pages/GlobalCambridge';
import RoyalSociety from './pages/RoyalSociety';
import YogaOrphanages from './pages/YogaOrphanages';
import VoluntaryWork from './pages/VoluntaryWork';
import NagpurYoga from './pages/NagpurYoga';
import Blog from './pages/Blog';
import ChiaConference2026 from './pages/ChiaConference2026';
import CislCanopy2026 from './pages/CislCanopy2026';
import MyResearch from './pages/MyResearch';
import SocialTippingPoints from './pages/SocialTippingPoints';
import WhereTheAnalogyBreaks from './pages/WhereTheAnalogyBreaks';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/my-quest" element={<MyQuest />} />
        <Route path="/my-research" element={<MyResearch />} />
        <Route path="/my-research/social-tipping-points" element={<SocialTippingPoints />} />
        <Route path="/my-research/where-the-analogy-breaks" element={<WhereTheAnalogyBreaks />} />
        <Route path="/treasure" element={<Treasure />} />
        <Route path="/treasure/british-library" element={<BritishLibrary />} />
        <Route path="/treasure/royal-society" element={<RoyalSociety />} />
        <Route path="/treasure/my-clicks" element={<MyClicks />} />
        <Route path="/treasure/eco-veterans" element={<EcoVeterans />} />
        <Route path="/treasure/global-cambridge" element={<GlobalCambridge />} />
        <Route path="/voluntary-work" element={<VoluntaryWork />} />
        <Route path="/voluntary-work/nagpur" element={<NagpurYoga />} />
        <Route path="/voluntary-work/pune" element={<YogaOrphanages />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/chia-annual-conference-2026" element={<ChiaConference2026 />} />
        <Route path="/blog/cisl-canopy-2026" element={<CislCanopy2026 />} />
      </Routes>
    </Router>
  );
}

export default App;
